export default __webpack_public_path__ + "static/media/009-I.54156248.svg";